import Notifications from './notifications';
import GraphqlBuilder from "utils/request/graphql/builder";
import _ from 'lodash';
import MutationEmployeePushNotificationToken from "graphql/mutations/MutationEmployeePushNotificationToken";
import { colorList } from "utils/colors";
import { constantsActive } from 'utils/constants/constants'
import HelperPlatform from "utils/helper-platform";
import * as Device from 'expo-device';
import { configClient } from 'components/provider/ConfigProvider'
import Constants from 'expo-constants'

const PushNotificationService = {
	
	projectId: () => {
		const projectId = Constants.expoConfig?.extra?.eas?.projectId;
		if( projectId ) {
			return projectId;
		}
		
		return null;
	},
	
	errors: [],
	addError: ( value ) => {
		PushNotificationService.errors.push( value );
	},
	
	log: ( value ) => {
		console.prefix('pushNotification', value );
	},
	
	isAvailable: () => {
		return Notifications !== null && HelperPlatform.isNotWeb() && Device.isDevice && configClient.url() !== null;
	},

	configureChannel: async() => {
		if( Notifications !== null && HelperPlatform.isAndroid() ) {
			await Notifications.setNotificationChannelAsync( 'default', {
				name: 'default',
				sound: 'default',
				importance: Notifications.AndroidImportance.DEFAULT,
				vibrationPattern: [ 0, 250, 250, 250 ],
				lightColor: colorList.PRIMARY.primary,
			});
		}
	},
	
	/**
	 *
	 * @returns {Promise<{token: string}>}
	 */
	getToken: async() => {
		let token = null;
		
		if ( PushNotificationService.isAvailable() ) {
			try {
				await PushNotificationService.configureChannel();
				const projectId = PushNotificationService.projectId();
				
				token = ( await Notifications.getExpoPushTokenAsync({
					projectId: projectId
				}) ).data;
			} catch ( e ) {
				PushNotificationService.addError( e.message );
				console.log('testy5', 'error', e );
			}
		}
		
		return {
			token: token
		};
	},
	
	getCurrentPermissions: async() => {
		if( Notifications === null ) {
			return null;
		}

		try {
			return await Notifications.getPermissionsAsync()
		} catch ( e ) {
			PushNotificationService.addError( e.message );
			console.log('testy5', 'error', e );
		}
		
		return null;
	},
	
	isPermissionGranted: ( settings ) => {
		if( Notifications === null || !settings ) {
			return false;
		}
		if( settings.ios?.status !== undefined ) {
			return [
				Notifications.IosAuthorizationStatus.AUTHORIZED,
				Notifications.IosAuthorizationStatus.PROVISIONAL,
				Notifications.IosAuthorizationStatus.EPHEMERAL,
			].includes( settings.ios.status );
		}
		return settings.granted === true;
	},
	
	isPermissionDenied: ( settings ) => {
		if( Notifications === null || !settings ) {
			return true;
		}
		if( PushNotificationService.isPermissionGranted( settings ) ) {
			return false;
		}
		if( settings.status === 'undetermined' || settings.canAskAgain ) {
			return false;
		}
		
		return !settings.granted || settings.ios?.status === Notifications.IosAuthorizationStatus.DENIED
	},
	
	canAskPermission: ( settings ) => {
		return !PushNotificationService.isPermissionDenied( settings ) && !PushNotificationService.isPermissionGranted( settings )
	},
	
	requestPermission: async() => {
		if( Notifications === null ) {
			return null;
		}

		try {
			await PushNotificationService.configureChannel();
			const settings = await Notifications.requestPermissionsAsync();
			
			if( PushNotificationService.isPermissionGranted( settings ) ) {
				return 'granted';
			}
			return settings.ios ? 'denied' : settings.status;
		} catch ( e ) {
			PushNotificationService.addError( e.message );
			console.log('testy5', 'error', e );
		}
		
		return null
	},
	
	/**
	 *
	 * @returns {Promise<{token: null}>}
	 */
	register: async() => {
		let token = null;
		
		try {
			if ( PushNotificationService.isAvailable() ) {
				const currentPermissions = await PushNotificationService.getCurrentPermissions();
				
				let finalStatus = PushNotificationService.isPermissionGranted( currentPermissions ) ? 'granted' : null;
				if( PushNotificationService.canAskPermission( currentPermissions ) ) {
					finalStatus = await PushNotificationService.requestPermission();
				}
				
				// Not granted? Do not return a token
				if ( finalStatus !== 'granted' ) {
					return {
						token: null
					}
				}
				
				// Get the token data
				const tokenData = await PushNotificationService.getToken();
				
				// Set the token
				token = tokenData.token;
			}
			
		} catch ( e ) {
			PushNotificationService.addError( e.message );
			console.log('testy5', 'error', e );
		}
		
		return {
			token: token
		};
	},
	
	/**
	 *
	 * @param token
	 * @param active
	 * @param callbackSuccess
	 * @param callbackError
	 * @returns {boolean}
	 */
	mutate: ( token, active = constantsActive.YES, { callbackSuccess = null, callbackError = null } = {} ) => {
		if( token === null ) {
			if( _.isFunction( callbackSuccess ) ) {
				callbackSuccess( [] );
			}
			
			return false;
		}
		
		new GraphqlBuilder()
			.addQuery( 'employee_push_token', MutationEmployeePushNotificationToken, {
				employee_guid: '::employee_guid',
				code: token,
				active: active,
			})
			.setOnError( callbackError )
			.setOnSuccess( result => {
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess( result );
				}
			})
			.execute();
	}
}

export default PushNotificationService
